import React from 'react';
import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';
import { QFormControl, QMultiSelect, QSelectPlaceholder, QText } from '@qualio/ui-components';
import { SeverityType } from '../../../types/eventMetadata';
import { EMPTY_FILTER_VALUE } from '../../../types/qualityEvent';
import { emptyAwareFilterOption } from './emptyAwareFilterOption';

export const SeverityFilter = ({
  isLoadingSeverities,
  severities,
}: {
  isLoadingSeverities: boolean;
  severities: SeverityType[];
}) => {
  const { t } = useTranslation();
  const options: Array<{ value: string; label: React.ReactNode }> = [
    { value: EMPTY_FILTER_VALUE, label: <em>{t('common.labels.emptySeverities')}</em> },
    ...severities.map((severity) => ({
      value: severity.id,
      label: severity.name,
    })),
  ];

  return (
    <QFormControl label={t('common.labels.severity')} data-cy="severity-filter" w="300px">
      <Controller
        name={'severity_ids'}
        render={({ field: { onChange, value } }) => (
          <QMultiSelect
            options={options}
            aria-label="severity-filter"
            onChange={(val) => onChange(val.map((c) => c.value))}
            value={value ?? []}
            isLoading={isLoadingSeverities}
            filterOption={emptyAwareFilterOption}
          >
            <QSelectPlaceholder>
              <QText>{t('common.filters.filterBySeverity')}</QText>
            </QSelectPlaceholder>
          </QMultiSelect>
        )}
      />
    </QFormControl>
  );
};

export default SeverityFilter;
